<div class="item-container d-flex flex-column">
  <div class="item-header">
    <h6 class="text-center">
      Add working time</h6>
    <div class="edit-icons" mat-dialog-close>
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content flex-grow-1 w-100">

    <div class="user-profile name mt-3">
      <div class="profile-img me-2" [appBackgroundImg]="empDetails?.profile_picture"></div>
      <div class="">
        <div class="main-head p-name">{{empDetails.first_name}} {{empDetails.last_name}}</div>
        <div class="sub-head">{{empDetails.email}}</div>
      </div>
    </div>

    <!-- <div>
      <label for="">Date</label>
      <div class="in-box">
        <div class="form-control form-control-date">
          {{empDetails.st_dt}}
        </div>
      </div>
    </div> -->

    <form [formGroup]="timeForm">
      <div class="d-flex flex-wrap gap-3">
        <div class="m-w-200 mt-3">
          <label for="startTime" class="">Start Time</label>
          <input formControlName="startTime" [ngxTimepicker]="picker" [format]="24" class="form-control num-b"
            placeholder="Select Start Time" />
          <ngx-material-timepicker #picker></ngx-material-timepicker>
          <mat-error *ngIf="(timeForm.get('endTime')?.value && !timeForm.get('startTime')?.value && timeForm.get('startTime')?.invalid) || 
          !timeForm.get('startTime')?.value && timeForm.get('startTime')?.touched">
            This field is required
          </mat-error>
        </div>
        <div class="m-w-200 mt-3">
          <label for="endTime" class="">End Time</label>
          <input formControlName="endTime" [ngxTimepicker]="epicker" [format]="24" class="form-control num-b"
            placeholder="Select End Time" />
          <ngx-material-timepicker #epicker></ngx-material-timepicker>
          <mat-error *ngIf="!timeForm.get('startTime')?.value && !timeForm.get('endTime')?.value && timeForm.get('endTime')?.touched || 
          !timeForm.get('endTime')?.value && timeForm.get('endTime')?.touched">
            This field is required
          </mat-error>
        </div>
      </div>

      <div class="d-flex flex-wrap gap-3">
        <div class="m-w-200 mt-3">
          <label for="breakStartTime">Break Time In</label>
          <input formControlName="breakStartTime" [ngxTimepicker]="bpicker" [format]="24" class="form-control num-b"
            placeholder="Select Break Start Time" />
          <ngx-material-timepicker #bpicker></ngx-material-timepicker>
          <!-- <mat-error
            *ngIf="(timeForm.get('breakEndTime')?.value && !timeForm.get('breakStartTime')?.value && timeForm.get('breakStartTime')?.invalid) || 
            !timeForm.get('breakStartTime')?.value && timeForm.get('breakStartTime')?.touched">
            This field required </mat-error> -->
        </div>
        <div class="m-w-200 mt-3">
          <label for="breakEndTime">Break Time Out</label>
          <input formControlName="breakEndTime" [ngxTimepicker]="bepicker" [format]="24" class="form-control num-b"
            placeholder="Select Break End Time" />
          <ngx-material-timepicker #bepicker></ngx-material-timepicker>
          <!-- <mat-error
            *ngIf="(timeForm.get('breakStartTime')?.value && !timeForm.get('breakEndTime')?.value && timeForm.get('breakEndTime')?.invalid) ||
            !timeForm.get('breakEndTime')?.value && timeForm.get('breakEndTime')?.touched">
            This field required </mat-error> -->
        </div>
      </div>

      <div class="d-flex flex-wrap gap-3">
        <div class="m-w-200 mt-3">
          <label for="clockInLatitude">Clock In Latitude</label>
          <input formControlName="clockInLatitude" class="form-control" type="text" placeholder="Clock In Latitude" />
          <!-- <mat-error *ngIf="timeForm.get('clockInLatitude')?.hasError('invalidLatitude') && timeForm.get('clockInLatitude')?.touched">
            Latitude must be between -90 and 90.
          </mat-error>
          <mat-error
            *ngIf="(timeForm.get('clockInLongitude')?.value && !timeForm.get('clockInLatitude')?.value && timeForm.get('clockInLatitude')?.invalid) || 
             !timeForm.get('clockInLatitude')?.value && timeForm.get('clockInLatitude')?.touched">
            This field required </mat-error> -->
        </div>
        <div class="m-w-200 mt-3">
          <label for="clockInLongitude">Clock In Longitude</label>
          <input formControlName="clockInLongitude" class="form-control" type="text" placeholder="Clock In Longitude" />
          <!-- <mat-error *ngIf="timeForm.get('clockInLongitude')?.hasError('invalidLongitude') && timeForm.get('clockInLongitude')?.touched">
            Longitude must be between -180 and 180.
          </mat-error>
          <mat-error
            *ngIf="(timeForm.get('clockInLatitude')?.value && !timeForm.get('clockInLongitude')?.value && timeForm.get('clockInLongitude')?.invalid) || 
            !timeForm.get('clockInLongitude')?.value && timeForm.get('clockInLongitude')?.touched">
            This field required </mat-error> -->
        </div>
      </div>
      <div class="d-flex flex-wrap gap-3">
        <div class="m-w-200 mt-3">
          <label for="clockOutLatitude">Clock Out Latitude</label>
          <input formControlName="clockOutLatitude" class="form-control" type="text" placeholder="Clock Out Latitude" />
          <!-- <mat-error *ngIf="timeForm.get('clockOutLatitude')?.hasError('invalidLatitude') && timeForm.get('clockOutLatitude')?.touched">
            Latitude must be between -90 and 90.
          </mat-error>
          
          <mat-error
            *ngIf="(timeForm.get('clockOutLongitude')?.value && !timeForm.get('clockOutLatitude')?.value && timeForm.get('clockOutLatitude')?.invalid) || 
            !timeForm.get('clockOutLatitude')?.value && timeForm.get('clockOutLatitude')?.touched">
            This field required </mat-error> -->
        </div>
        <div class="m-w-200 mt-3">
          <label for="clockOutLongitude">Clock Out Longitude</label>
          <input formControlName="clockOutLongitude" class="form-control" type="text"
            placeholder="Clock Out Longitude" />
          <!-- <mat-error *ngIf="timeForm.get('clockOutLongitude')?.hasError('invalidLongitude') && timeForm.get('clockOutLongitude')?.touched">
            Longitude must be between -180 and 180.
          </mat-error>
          <mat-error
            *ngIf="(timeForm.get('clockOutLatitude')?.value && !timeForm.get('clockOutLongitude')?.value && timeForm.get('clockOutLongitude')?.invalid) || 
            !timeForm.get('clockOutLongitude')?.value && timeForm.get('clockOutLongitude')?.touched">
            This field required </mat-error> -->
        </div>
      </div>
      <div class="d-flex gap-3 mt-3 mb-3 justify-content-center">
      </div>
    </form>
  </div>
  <div class="item-footer">
    <div class="d-flex align-items-center justify-content-center flex-wrap position-relative">
      <button type="button" style="min-width: 180px;" (click)="onCancel()"
        class="btn btn-outline-primary mt-2 mt-lg-3 me-3">Cancel</button>
      <button mat-raised-button color="primary" (click)="onSubmit()" type="submit" style="min-width: 180px;"
        class="btn btn-primary mt-2 mt-lg-3 me-3">Submit</button>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>